import { connect } from 'react-redux';

import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import { notify } from 'app/developer-v3/store/shared/actions';
import {
  currentAuthFields,
  currentAuthType,
  currentLegacyTrigger,
  currentPlatformVariablesList,
  currentRequestTemplate,
  currentTestRequest,
  currentTriggerClean,
  isCurrentAppDefinitionSaving,
  selectIsAuthSetupComplete,
  selectIsServiceSetup,
} from 'app/developer-v3/selectors';
import { SERVICE_TYPE } from 'app/developer-v3/constants';

import Wrapper from './Wrapper';

import type { LegacyTriggerOperationSchema } from 'app/developer-v3/platformSchema/legacy';
import type { TriggerOperationSchema } from 'app/developer-v3/platformSchema/trigger';

const mapStateToProps = state => {
  const triggerLegacy = currentLegacyTrigger(state);

  return {
    authFields: currentAuthFields(state),
    authType: currentAuthType(state),
    getSuggestions: currentPlatformVariablesList(SERVICE_TYPE.triggers, state),
    hasLoaded: CliAppDefinition.selectors.all.hasLoaded(state),
    isAuthSetupComplete: selectIsAuthSetupComplete(state),
    isLoading: CliAppDefinition.selectors.isLoading(state),
    isSaving: isCurrentAppDefinitionSaving(state),
    isTriggerSetup: selectIsServiceSetup(state),
    requestTemplate: currentRequestTemplate(state),
    testRequest: currentTestRequest(state),
    trigger: currentTriggerClean(state),
    ...(triggerLegacy ? { triggerLegacy } : {}),
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    dispatch(DeveloperActions.resetTestRequest());
    dispatch(DeveloperActions.resetTestLogs());
  },

  saveTriggerOperation(
    operation: TriggerOperationSchema,
    operationLegacy?: LegacyTriggerOperationSchema
  ) {
    dispatch(
      props.params.triggerKey === 'new'
        ? notify.failure('Bargle! Please save your trigger in settings first!')
        : DeveloperActions.saveTriggerOperation(operation, operationLegacy)
    );
  },

  setUnsavedChanges(hasUnsavedChanges: boolean) {
    dispatch(DeveloperActions.setUnsavedChanges(hasUnsavedChanges));
  },

  warnAboutTypeChange() {
    dispatch(
      notify.info(
        'Please be sure to save your changes. Changing types will lose any unsaved data for this request'
      )
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(Wrapper));
